import React, { useState, useEffect, useContext,useRef } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import WYSIWYGEditor from "components/wysiwyg/wysiwyg";
import Input from "components/input/input";
import Select from "components/select/select";
import Toggle from "components/toggle/toggle";
import DateInput from "components/input-group/date-input";
import update from "immutability-helper";
import LinkGroupSelect from "components/link-group/LinkGroupSelect";
import _ from "lodash";
import FileUpload from "components/file-upload/file-upload";
import { useDialogHook } from "utils/customhooks";
import InputGroup from "components/input-group/input-group";
import { urlSerializer, isValidYoutubeVideoLink,currentLang,cleanQuillContent } from "utils/utils";
import LoadingIndicator from "assets/svg/loading-indicator";
import EditThumbnailModal from "./edit-thumbnail";
import AdultContentWarning from "./adult-content-warning";
import CreatableSelect from "components/select/creatable";
import validator from "validator";
import moment from "moment";
import { isValidHttpUrl, maxUploadSize, mediaTypes_init, mediaSubTypes_init, groupTypes } from "utils/constant";
import CustomCheckbox from "components/checkbox/custom-checkbox";

import { usePrivacies } from "redux/modules/privacy/hooks";
import { useMediaTypes } from "redux/modules/media-type/hooks";
import { useMediaSubTypes } from "redux/modules/media-sub-type/hooks";
import { useMilestones } from "redux/modules/milestone/hooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";

import UpgradePremium from "components/subscription/upgrade-premium";
import { SubscriptionContext } from "context/subscription";
import LockOutlineIcon from "assets/svg/upgrade/lock-outline-icon";
import { usePlacesWidget } from "react-google-autocomplete";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import PopInfo from "components/info-popup/pop-info";
import { useWindowDimensions } from "utils/customhooks";

export default function EditMilestoneModal({
  hide,
  userData,
  profile,
  milestone,
  ...props
}) { 
  const {t} = useTranslation();
  const { http } = global.services;
  const currentDate = moment().format("YYYY-MM-DD");
  const maxSelectedImages = 50;
  const { isSubscribed } = useContext(SubscriptionContext);
  let dontShowTut = useRef(false);
  let {isMobile} = useWindowDimensions();
  const {
    refresh: refreshPrivacies,
    initialize: initializePrivacies,
    privacies,
    setPrivacies,
  } = usePrivacies();

  const {
    refresh: refreshMediaTypes,
    initialize: initializeMediaTypes,
    types: mediaTypes,
    setMediaTypes,
  } = useMediaTypes();

  const {
    refresh: refreshMediaSubTypes,
    initialize: initializeMediaSubTypes,
    types: mediaSubTypes,
    setMediaSubTypes,
  } = useMediaSubTypes();
  

  const { organizeBy, buttonCount, setButtonCount } = useMilestones();

  const [state, setState] = useState({
    title: "",
    role: "",
    platform: "",
    location: "",
    category: [],
    privacy: "",
    description: "",
    date_note: "",
    loading: false,
    validationErrors: null,
    currentButtonCount: buttonCount || 0,

  });
  const [startDate, setStartDate] = useState({
    day: null,
    month: null,
    year: null,
    approximately: false,
  });
  const [endDate, setEndDate] = useState({
    day: null,
    month: null,
    year: null,
    approximately: false,
    present: false,
  });
  const [jobs, setJobs] = useState([{ job_role: "", description: "" }]);
  const [linkType, setLinkType] = useState([]);
  const [removelinkType, setRemoveLinkType] = useState([]);
  const [adultContent, setAdultContent] = useState(true);
  const [featured, setFeatured] = useState(true);
  // const modal = useDialogHook(TagPeopleModal);
  const edit = useDialogHook(EditThumbnailModal);
  const adultContentWarning = useDialogHook(AdultContentWarning);
  const [preview, setPreview] = useState(null);
  const [cropFile, setCropFile] = useState(null);
  const [btnAddPositionHidden, setBtnAddPositionHidden] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [mediaTypeOptions, setMediaTypeOptions] = useState(mediaTypes);
  const [positionOptions, setPositionOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const uploadSizeModal = useDialogHook(UploadSizeModal);

  const handleInputChange = async(e) => {
    const { name, value } = e.target;

    const hasValue = (value) => {
      return categoriesOptions.includes(value[value.length - 1]);
    }

    if (name === "category" && !hasValue(value)) {
      const newValue = value[value.length - 1];
      const data = await createCategory(newValue);
      const indx = value.findIndex(v => {
       return v.label === newValue.label;
      });
      if(indx > -1) value[indx].value = data.id;
    }

    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  };

  const { ref } = usePlacesWidget({
    apiKey:process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => {
      let address = place.formatted_address
      let postCode = place.address_components
      .find(
        (component) =>
          component.types.includes("postal_code") // Exclude postcode
      );
      if(postCode?.long_name){
        address = address.replace(postCode?.long_name, "").replace(/\s+,/, ",").trim();
      }
       
      setState((prev) => ({
        ...prev,
        location: address,
        validationErrors: { ...state.validationErrors, location: null },
      }));
    }
  });

  const onAddTypeLink = (type) => {
    let newLinkType = null;

    if (type === "Link") {
      newLinkType = { type: 1, subType: "Link", value: "", label: "Website" };
    }
    else if (type === "Video Embed") {
      newLinkType = { type: 1, subType: "Video Embed", value: "", label: "Watch", orientation :"Landscape"};
    }
    else if (type === "Video File") {
      newLinkType = { type: 1, subType: "Upload", value: "", label: "Watch" };
    }
    else if (type === "Audio File") {
      newLinkType = { type: 1, subType: "Audio File", value: "", label: "Listen" };
    }
    else if (type === "Images") {
      newLinkType = { type: 1, subType: "Multiple Images", value: [], label: "Images" };
    }
    else if (type === "Read") {
      newLinkType = { type: 1, subType: "Upload", value: "", label: "Read" };
    }

    newLinkType.order = linkType.length;
      

    let payload = _.clone(linkType);
    payload.push(newLinkType);
    setLinkType(payload);
    setState((prev) => ({
      ...prev,
      currentButtonCount: state.currentButtonCount + 1
    }));
  };

  const onRemoveTypeLink = (index) => {
    // if (linkType.length === 1) return;

    // let types = mediaTypeOptions.map((mt) => {
    //   if (mt.value === linkType[index].type) {
    //     const { selected, ...val } = mt;
    //     return val;
    //   }
    //   return mt;
    // });
    // setMediaTypeOptions((prev) => types);

    let payload = _.clone(linkType);
    let removedPayload = _.clone(removelinkType);
    removedPayload.push(payload[index]);
    setRemoveLinkType(removedPayload);

    let result = update(payload, { $splice: [[index, 1]] }); //remove

    setLinkType(result);
    setState((prev) => ({
      ...prev,
      currentButtonCount: state.currentButtonCount - 1
    }));
  };

  const onSelectTypeLink = (e, index) => {
    // let types = mediaTypeOptions.map((mt) => {
    //   if (mt.value === e.value) {
    //     return {
    //       ...mt,
    //       selected: true,
    //     };
    //   } else if (linkType[index].type === mt.value) {
    //     const { selected, ...val } = mt
    //     return val
    //   }

    //   return mt
    // });
    // setMediaTypeOptions((prev) => types);

    let payload = _.clone(linkType);
    let result = update(payload, {
      [index]: {
        type: { $set: e.value },
      },
    }); //remove
    setLinkType(result);
  };

  const onSelectSubTypeLink = (e, index) => {
    let payload = _.clone(linkType);
    let params = {
      subType: { $set: e },
      value: { $set: "" },
    };
    if (payload.placeholder) {
      params.placeholder = { $set: "" };
    }
    let result = update(payload, {
      [index]: params,
    }); //remove
    setLinkType(result);
  };

  const onRemoveMediaLink = (e, index) => {
    let payload = _.clone(linkType);
    let results = linkType[index]["value"].filter((f, i) => i !== e);
    payload[index]["value"] = results.length > 0 ? results : "";

    // check if errorMessages has multiple_images and remove this error if results.length <= 10
    if (errorMessages?.multiple_images && results.length <= 10) {
      delete errorMessages.multiple_images;
    }

    setLinkType(payload);
    setErrorMessages({ ...errorMessages });
  };

  const onUploadLink = async (e, index) => {
    let payload = _.clone(linkType);
    let result = update(payload, {
      [index]: {
        value: { $set: e },
      },
    }); //remove
    setLinkType(result);
  };

  const showUploadAlert = () => {
    uploadSizeModal({}, (callback) => {
      console.log("callback", callback);
    });
  };

  const onUploadMultipleLink = async (e, index) => {
    let fileSize = 0;
    let payload = _.clone(linkType);
    let currValue = linkType[index].value ?? {};
    e.forEach((f) => {
      fileSize += parseFloat(f.size);
    });

    if (Array.isArray(currValue)) {
      currValue.forEach((cv) => {
        if (cv.media) {
          fileSize += parseFloat(cv.media.file_size || 0);
        } else {
          fileSize += cv.size || 0;
        }
      });
    } 
    if (fileSize < maxUploadSize) {
      let result = update(payload, {
        [index]: {
          value: { $set: [...currValue, ...e] },
        },
      }); 
      setLinkType(result);
    } else {
      setErrorMessages({
        ...errorMessages,
        [`media.${index}.value`]: "The file is too large. Maximum size is 50MB.",
      });
      showUploadAlert();
    }
  };

  const onTypeLink = (e, index) => {
    let payload = _.clone(linkType);
    let result = update(payload, {
      [index]: {
        value: { $set: e.target.value },
      },
    }); //remove
    setLinkType(result);
  };

  const onBlurTypeLink = (index) => {
    let payload = _.clone(linkType);
    let value = payload[index].value;

    if (payload[index].subType === "Link" || payload[index].subType.label === "Link") {
      if (value && !value.includes("http://") && !value.includes("https://")) {
        value = `https://${value}`;
      }

      let result = update(payload, {
        [index]: {
          value: { $set: value },
        },
      }); //remove
      setLinkType(result);
    }
  };

  const onChangeInput = (e, index) => {
    let payload = _.clone(jobs);
    let result = update(payload, {
      [index]: {
        description: { $set: e.target.value },
      },
    }); //remove
    setJobs(result);
  };

  const onAddPosition = () => {
    if (jobs.length === 5) return;

    let payload = _.clone(jobs);
    payload.push({ job_role: "", description: "" });
    setJobs(payload);

    if (jobs.length < 4) setBtnAddPositionHidden(false);
    else setBtnAddPositionHidden(true);
  };

  const onSelectJobRole = async (e, index) => {
    let _remove = jobs[index] ? jobs[index].job_role : {};
    let _value = e ? e.value : "";
    let opt = e ? e : "";

    if (!_value) {
      _remove = jobs[index].job_role;
    }

    if (e && e.__isNew__) {
      let createdPosition = await createPosition(e);
      opt = { label: createdPosition.name, value: createdPosition.id };
      _value = createdPosition.id;

      setSelectJobRole(_remove, _value, opt, index);
    } else {
      setSelectJobRole(_remove, _value, opt, index);
    }
  };

  const setSelectJobRole = (_remove, _value, opt, index) => {
    let types = positionOptions.map((op) => {
      if (op.value === _value) {
        return {
          ...op,
          selected: true,
        };
      } else if (op.value === _remove.value) {
        const { selected, ...val } = op;
        return val;
      }
      return op;
    });
    setPositionOptions((prev) => types);

    let payload = _.clone(jobs);
    let result = update(payload, {
      [index]: {
        job_role: { $set: opt },
      },
    }); //remove
    setJobs(result);
  };

  const createPosition = async (e) => {
    try {
      let { data } = await http.post("public/positions", {
        user_id: profile.user.id,
        user_profile_id: profile.id,
        position: e.label,
      });
      getPositions();
      return data.data;
    } catch (err) {
      console.log(err);
    }
  };

  const createCategory = async (e) => {
    try {
      let { data } = await http.post("public/categories", {
        user_id: profile.user.id,
        user_profile_id: profile.id,
        category: e.label,
      });
      getCategories();
      return data.data;
    } catch (err) {
      console.log(err);
    }
  };

  const onRemoveJobRole = (index) => {
    if (jobs.length === 1) return;

    // let types = positionOptions.map(op => {
    //   if (op.value === jobs[index].job_role.value) {
    //     const { selected, ...val } = op
    //     return val
    //   }
    //   return op;
    // })
    // setPositionOptions((prev) => types)

    let payload = _.clone(jobs);
    let result = update(payload, { $splice: [[index, 1]] }); //remove
    setJobs(result);

    if (result.length < 5) setBtnAddPositionHidden(false);
    else setBtnAddPositionHidden(true);
  };

  const onUploadImage = async (file) => {
    setCropFile(file);
  };


  const onEditThumbnail = (image, type) => {
    if (image) {
      edit({ image: image, type: type, returnType: "blob" }, (result) => {
        if (result) {
          const { imageFile, preview } = result;
          setCropFile(imageFile);
          setPreview(preview);
        }
      });
    }
  };

  useEffect(() => {
    const errors = Object.values(errorMessages);
    if(errors.length > 0) {
      const message = [];
      errors.forEach(err => {
        if(typeof err === "string") {
          message.push(err);
        } else if(Array.isArray(err)) {
          message.push(err.join(" "));
        }
      });
      toast.error(message.join(" "), { position: 'top-center'})
    }

  }, [errorMessages]);

  const submit = async () => {
    let errors = {};
    setErrorMessages(errors);
    let thumbnail = cropFile;

    //validate date
    let concatStartDate = `${startDate.year}-${startDate.month ?? "00"}-${
      startDate.day ?? "00"
    }`;
    let concatEndDate = endDate.present
      ? null
      : endDate.year
      ? `${endDate.year}-${endDate.month ?? "00"}-${endDate.day ?? "00"}`
      : null;

    if (!_.isEmpty(concatStartDate) && !_.isEmpty(concatEndDate)) {
      if (new Date(concatStartDate) > new Date(concatEndDate)) {
        errors = {
          ...errors,
          "start_date.day": [""],
          "start_date.month": [""],
          "start_date.year": [""],
          "end_date.day": [""],
          "end_date.month": [""],
          "end_date.year": [""],
          errorDates: ["The start date must be less than the end date."],
        };
      }
    }
    //end validate date

    if (startDate.day > 31) {
      errors = {
        ...errors,
        "start_date.day": ["The day field should not be greater than 31."],
      };
    }
    if (startDate.month > 12) {
      errors = {
        ...errors,
        "start_date.month": ["The month field should not be greater than 12."],
      };
    }
    if (endDate.day > 31) {
      errors = {
        ...errors,
        "end_date.day": ["The day field should not be greater than 31."],
      };
    }
    if (endDate.month > 12) {
      errors = {
        ...errors,
        "end_date.month": ["The month field should not be greater than 12."],
      };
    }

    //if (preview) thumbnail = await fetch(preview).then((res) => res.blob()); 
    let formData = new FormData();

    // attach profile type to filter
    formData.append("profile_type", profile.profile_type.type);

    // if (thumbnail) formData.append("thumbnail", thumbnail);
    formData.append("thumbnail", thumbnail);
    console.log('(!thumbnail && !!preview):', thumbnail, preview);
    formData.append("deleteThumbnail", (!thumbnail && !preview) ? 1 : 0);

    formData.append("user_id", userData.user.id);
    formData.append("user_profile_id", userData.profile.id);
    formData.append("title", state.title);
    const cleanDescription =state.description && cleanQuillContent(state.description.replace(/<span[^>]*style=['"]?\s*color\s*:\s*blue;?['"]?[^>]*>([\s\S]*?)<\/span>/gi,'$1'));
    formData.append("description", cleanDescription);
    formData.append("platform", state.platform);
    formData.append("location", state.location);
    formData.append("date_note", state.date_note);
    formData.append("order", milestone?.order || 0);

    // position
    jobs.forEach((p, index) => {
      if (typeof p.job_role === "object") {
        const { value } = p.job_role;
        formData.append(`position[${index}][job_role]`, value);
      } else {
        formData.append(`position[${index}][job_role]`, p.job_role);
      }
      formData.append(`position[${index}][description]`, p.description);
    });


    // position
    removelinkType.forEach((r, index) => {
      if (r.id) {
        formData.append(`remove[${index}][button_id]`, r.id);
      }
    });

    // media
    linkType.forEach(async (media, index) => {
      let mediaData = _.clone(media);
      if (mediaData.subType === "Link") {
        mediaData.type = mediaTypes_init.find((mt) => mt.label === "Website").value;
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Link").value;
        mediaData.is_media = false;
      }
      else if (mediaData.subType === "Video Embed") {
        mediaData.type = mediaTypes_init.find((mt) => mt.label === "Watch").value;
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Video Embed").value;
        mediaData.is_media = false;
      }
      else if (mediaData.subType === "Audio File") {
        mediaData.type = mediaTypes_init.find((mt) => mt.label === "Listen").value;
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Audio File").value;
        mediaData.is_media = true;
        if(typeof mediaData.value === "string" || mediaData.value instanceof File){
            errors = {
              ...errors,
              "images": ["Please wait until the audio is uploaded.."],
            };
            return toast.error(t('somethingWentWrong'));
          }
      }
      else if (mediaData.subType === "Multiple Images") {
        mediaData.type = mediaTypes_init.find((mt) => mt.label === "Images").value;
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Multiple Images").value;
        mediaData.is_media = true;
        for(let i = 0; i < mediaData.value.length; i++){
          if(mediaData.value[i].progress){
            errors = {
              ...errors,
              "images": ["Please wait until the image is uploaded.."],
            };
            return toast.error(t('somethingWentWrong'));
          }
        }
      }
      else if (mediaData.subType === "Upload") {
        if(mediaData.type === "Watch"){
          mediaData.type = mediaTypes_init.find((mt) => mt.label === "Watch").value
        }
        else{
          mediaData.type = mediaTypes_init.find((mt) => mt.label === "Read").value;
        }
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Upload").value;
        mediaData.is_media = true;
      }

      if(typeof mediaData.type === 'string'){
        mediaData.type = 1;
      }
      if(typeof mediaData.subTypeId === 'string'){
        mediaData.subTypeId = 5;
      }


      if (media.type || media.subType) {
        formData.append(`media[${index}][button_id]`, mediaData.id);
        formData.append(`media[${index}][type]`, mediaData.type);
        formData.append(`media[${index}][sub_type]`, mediaData.subTypeId);
        formData.append(`media[${index}][is_media]`, mediaData.is_media);
        formData.append(`media[${index}][order]`, mediaData.order);
        formData.append(`media[${index}][label]`, mediaData.label);
        formData.append(`media[${index}][orientation]`, mediaData?.orientation || []);

        if (typeof media.value === "object") {
          if (Array.isArray(media.value)) {
            media.value.map(async (file, fileIndex) => {
              if (file.hasOwnProperty("media")) {
                formData.append(
                  `media[${index}][media_id][${fileIndex}]`,
                  file.media_id
                );
                formData.append(
                  `media[${index}][value][${fileIndex}]`,
                  JSON.stringify(file)
                );
              } else {
                formData.append(`media[${index}][value][${fileIndex}]`, file);
              }
            });
          } else {
            if (media.value.hasOwnProperty("media")) {
              formData.append(
                `media[${index}][media_id][0]`,
                media.value.media_id
              );
              formData.append(
                `media[${index}][value][0]`,
                JSON.stringify(media.value)
              );
            } else {
              formData.append(`media[${index}][value][0]`, media.value);
            }
          }
        } else {
          //validate
          if (media?.subType?.is_link || !mediaData.is_media) {

            if (media.value) {
              if(media.value.includes('wikipedia.')){
                formData.append(`media[${index}][value]`, media.value);
              }
              else if (validator.isURL(media.value) && isValidHttpUrl(media.value)) {
                formData.append(`media[${index}][value]`, media.value);
              } else {
                errors = {
                  ...errors,
                  [`media.${media.value}.value`]: "Invalid url link.",
                };
              }
            } else {
              formData.append(`media[${index}][value]`, media.value);
            }
          } else {
            formData.append(`media[${index}][value]`, media.value);
          }
        }
        formData.append(`media[${index}][other_description]`, media.other_description);
      }
    });

    if (!_.isEmpty(errors)) {
      return setErrorMessages((prev) => ({ ...prev, ...errors }));
    }

    // if (state.category) formData.append("category", state.category.value);
    if(Array.isArray(state.category) && state.category?.length > 0) {
      state.category.forEach((category, index) => {
        console.log('state.category.forEach', category.value);
        formData.append(`category[${index}]`, category.value);
      });
    }
    if (state.privacy) formData.append("privacy", state.privacy.value);

    formData.append("is_featured", featured);
    formData.append("is_adult_content", adultContent);

    if (startDate.day) {
      formData.append("start_date[day]", startDate.day);
    }

    if (startDate.month) {
      formData.append("start_date[month]", startDate.month);
    }

    if (startDate.year) {
      formData.append("start_date[year]", startDate.year);
    } else {
      errors = {
        ...errors,
        "start_date.year": ["The year field is required."],
      };
    }

    if (endDate.day) formData.append("end_date[day]", endDate.day);
    if (endDate.month) formData.append("end_date[month]", endDate.month);
    if (endDate.year) formData.append("end_date[year]", endDate.year);

    formData.append("start_date[approximately]", startDate.approximately);
    formData.append("end_date[approximately]", endDate.approximately);
    formData.append("end_date[present]", endDate.present);
    formData.append("organize_by", organizeBy);
    formData.append("_method", "PUT");

    try {
      setSubmitLoading(true);
      const { data } = await http.post(
        `public/milestones/${milestone.id}`,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
          mode: "no-cors",
        }
      );
      updateButtonCount();
      getPositions();
      getCategories();
      hide({ success: true, data: data.data, dontShowTut:dontShowTut.current });
    } catch (err) {
      console.log("error@submit", err);
      const { data, status } = err;
      if (status === 422) {
        errors = data.errors;
      }
      toast.error(
        status === 422 ? data?.message : t('somethingWentWrong')
      );
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }

    setErrorMessages((prev) => ({ ...prev, ...errors }));
  };

  const updateButtonCount = async () => {
    const { data } = await http.get("public/milestones/media-types/count");
    setButtonCount(data?.count ?? 0);
  };

  const Footer = () => {
    return (
      <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2">
        <Button
          buttonName={t("cancel")}
          buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7.25rem]"
          buttonTextClass="text-black text-sm font-semibold"
          onClick={() => hide({dontShowTut:dontShowTut.current})}
        />
        <Button
          key="save-btn-category"
          buttonName={t("update")}
          buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7.25rem] box-border"
          buttonTextClass="text-white text-sm font-semibold flex items-center justify-center"
          onClick={submit}
          loadingIcon={
            submitLoading ? (
              <LoadingIndicator className="text-white w-4 h-4 ml-2" />
            ) : null
          }
        />
      </div>
    );
  };

  /**
   * This method will fetch
   * position filter options
   */
  const getPositions = async () => {
    try {
      const url = urlSerializer("public/positions", {
        user_profile_id: profile.id,
      });

      const lang = currentLang();
      const { data } = await http.get(url);
      const positions = data.map((position) => ({
        label: lang ? (position[lang] || position.name) : position.name,
        value: position.id,
        name: position.name
      }));
      setPositionOptions(positions);
    } catch (err) {
      console.log("error@getPositions", err);
      throw err;
    }
  };

  /**
   * This method will fetch
   * categories filter options
   */
  const getCategories = async () => {
    try {
      const url = urlSerializer("public/categories", {
        user_profile_id: profile.id,
      });
      const lang = currentLang();
      const { data } = await http.get(url);
      const categories = data.map((category) => ({
        // label: !profile.dateFormat ? (category.english_version || category.name) : category.name,
        value: category.id,
        label: lang ? (category[lang] || category.name) : !profile.dateFormat ? (category.english_version || category.name) : category.name
      }));
      setCategoriesOptions(categories);
    } catch (err) {
      console.log("error@getCategories", err);
      throw err;
    }
  };

  /**
   * This method will fetch
   * privacies filter options
   */
  const getPrivacies = async () => {
    try {
      const lang = currentLang();
      const { data } = await http.get("public/privacies");
      const privacies = data.map((category) => ({
        label: lang ? (category[lang] || category.name) : category.name,
        name: category.name,
        value: category.name,
      }));
      setPrivacies(privacies);
    } catch (err) {
      console.log("error@getPrivacies", err);
      throw err;
    }
  };

  /**
   * This method will fetch
   * media type filter options
   */
  const getMediaTypes = async () => {
    try {
      const { data } = await http.get("public/media-types");
      const types = data.map((type) => ({
        label: type.name,
        value: type.id,
      }));
      setMediaTypes(types);
      setMediaTypeOptions(types);
    } catch (err) {
      console.log("error@getMediaTypes", err);
      throw err;
    }
  };

  /**
   * This method will fetch
   * media sub type filter options
   */
  const getMediaSubTypes = async () => {
    try {
      const { data } = await http.get("public/media-sub-types");
      const types = data.map((type) => ({
        label: type.name,
        value: type.id,
        is_media_file: type.is_media_file,
        is_link: type.is_link,
        ...type.option,
      }));
      setMediaSubTypes(types);
    } catch (err) {
      console.log("error@getMediaSubTypes", err);
      throw err;
    }
  };

  const getMilestonePositions = async () => {
    let positions = [];
    try {
      const { data } = await http.get(
        `public/milestones/${milestone.id}/positions`
      );
      const lang = currentLang();
      data.forEach((p) => {
        positions.push({
          job_role: {
            label: p.position[lang] || p.position.name,
            value: p.position_id,
            name: p.position.name
          },
          description: p.description || "",
        });
      });

      setJobs(positions);
    } catch (err) {
      console.log("error@getMilestonePositions", err);
      throw err;
    }
  };

  const updateJobRoleOption = async () => {
    let types = positionOptions.map((op) => {
      const job = jobs.filter((j) => op.value === j.job_role?.value);
      if (!_.isEmpty(job)) {
        return {
          ...op,
          selected: true,
        };
      } else {
        const { selected, ...val } = op;
        return val;
      }
    });
    setPositionOptions(types);
  };

  useEffect(() => {
    getPositions();
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initializePrivacies) getPrivacies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPrivacies]);

  useEffect(() => {
    if (initializeMediaTypes) getMediaTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshMediaTypes]);

  useEffect(() => {
    if (initializeMediaSubTypes) getMediaSubTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshMediaSubTypes]);

  useEffect(() => {
    let startDate = {
      day: milestone.start_day,
      month: milestone.start_month,
      year: milestone.start_year,
      approximately: milestone.is_start_date_approximately ? true : false,
    };

    let endDate = {
      day: milestone.end_day,
      month: milestone.end_month,
      year: milestone.end_year,
      present: milestone.is_present ? true : false,
      approximately: milestone.is_end_date_approximately ? true : false,
    };

    // const category = categoriesOptions.filter(
    //   (c) => c.value === milestone.category_id
    // );
     
    const privacy = privacies.filter((c) => c.value === milestone.privacy);
    let categories = milestone.categories.map((item => {return {label: item[currentLang()] || item.name, value:item.id}}));
    let description = milestone.description;

    // if (!_.isEmpty(milestone.mention_names)) {
    //   let anchorTags = description.split("<a");

    //   Object.keys(milestone.mention_names).forEach((k) => {
    //     let isInsideAnchor = {
    //       found:false,
    //       keyName:"username"
    //     };

    //     anchorTags.forEach((tag) => {
    //       if (tag.includes(`${milestone.mention_names[k].username}</a>`)) {
    //         isInsideAnchor = {
    //           found: true,
    //           keyName: "username"
    //         };
    //         return true;
    //       } 
    //       else if(tag.includes(`${milestone.mention_names[k].p_name}</a>`)){
    //         isInsideAnchor = {
    //           found: true,
    //           keyName: "p_name"
    //         };
    //         return true;
    //       }
    //     });

    //     if (isInsideAnchor.found) {
    //       description = description.replaceAll(
    //         `${milestone.mention_names[k]?.[isInsideAnchor.keyName]}</a>`,
    //         // `[@${milestone.mention_names[k].p_username}]</a>`
    //         `@${milestone.mention_names[k].p_username}</a>`
    //       );
    //     }
    //   });
    // } 
    if (!_.isEmpty(milestone.mention_names)) {
      Object.keys(milestone.mention_names).forEach((k) => {
        const pUsername = milestone.mention_names[k]?.p_username;
    
        // Regex to match href containing username and capture the name between <a> and </a>
        // const regex = new RegExp(`(<a[^>]*href="[^"]*${username}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
        const regex = new RegExp(`(<a[^>]*key="[^"]*${pUsername}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
        description = description.replace(regex, (match, openingTag, name, closingTag) => {
          return `${openingTag}@${pUsername}${closingTag}`;
        });
      });
    }
    setState((prev) => ({
      ...prev,
      id: milestone.id,
      title: milestone.title,
      platform: milestone.platform || "",
      location: milestone.location || "",
      date_note: milestone.date_note || "",
      // category: prev.category || category[0],
      category:  categories || [],
      privacy: privacy[0],
      description,
    }));

    if (milestone.thumbnail) {
      setPreview(milestone.thumbnail.url);
    }

    if (!_.isEmpty(milestone.media_type)) {
      let links = [];

      milestone.media_type.forEach((media) => {
        const { name, option, ...rest } = media.sub_type;
        if (name === "Multiple Images") {
          links.push({
            id: media.id,
            type: media.type.name,
            subType: name,
            subTypeId: media.sub_type.id,
            order: media.order,
            label: media.label,
            value: media.media,

          });
        } else {
          let val = {
            id: media.id,
            type: media.type.name,
            subType: name,
            subTypeId: media.sub_type.id,
            order: media.order,
            label: media.label,
            value: media.url,
            orientation:media?.orientation,
            fav_icon: media?.fav_icon?.url
          };

          if (media.hasOwnProperty("media") && media.media.length > 0) {
            val.value = media.media[0];
            val.placeholder = media.media[0]["media"]["file_name"];
          } else {
            val.value = media.url;
          }
          val.other_description = media?.other_description;
          links.push(val);
        }
      });
      setLinkType(links);
    }

    setStartDate((prev) => ({
      ...prev,
      ...startDate,
    }));
    setEndDate((prev) => ({
      ...prev,
      ...endDate,
    }));

    setFeatured(() => (milestone.is_featured ? true : false));
    setAdultContent(() => (milestone.is_adult_content ? false : true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestone, privacies, mediaTypes]);

  useEffect(() => {
    let types = mediaTypeOptions.map((mt) => {
      let exist = linkType.filter((l) => l.type === mt.value);
      if (exist.length > 0) {
        return {
          ...mt,
          selected: true,
        };
      } else {
        const { selected, ...val } = mt;
        return val;
      }
    });
    setMediaTypeOptions((prev) => types);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkType]);

  useEffect(() => {
    getMilestonePositions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestone]);

  useEffect(() => {
    updateJobRoleOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobs]);

  // useEffect(() => {
  //   // check if startDate > currentDate
  //   if (
  //     `${startDate.year ?? "00"}-${startDate.month ?? "00"}-${
  //       startDate.day ?? "00"
  //     }` > currentDate
  //   ) {
  //     endDate.present = false;
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [startDate]);

  const onLabel = async (e, index) => {
    let payload = _.clone(linkType);
    let result = update(payload, {
      [index]: {
        label: { $set: e.target.value },
      },
    }); 
    setLinkType(result);
  }
  const facebookOrient = async (e, index) => {
      let payload = _.clone(linkType);
      let result = update(payload, {
        [index]: {
          orientation: { $set: e.value },
        },
      }); 
      console.log(result)
      setLinkType(result);
    }

  const handleDeleteImage = () => {
    // TODO: delete
    setCropFile(null);
    setPreview(null);
  };

  const handleSetAdultContent = (value) => {
    const dontShowAgain = localStorage.getItem("dontShowAdultContentWarning");
    if(!value && !dontShowAgain){

      adultContentWarning({}, (result) => {
        if (result) {
          setAdultContent(() => (value));
        }
      });
    }
    else {
      setAdultContent(() => (value));
    }
  };


  return (
    <div className="w-full relative smooth-dnd-parent">
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-18/20 2md:w-17/20 3md:w-15/20 4md:w-13/20 1xl:w-11/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full relative">
        {/* header */}
        <ModalHeader title={t('editMilestone')} hide={hide} popInfoType="edit_milestone" showPopInfo={true}/>
        {/* content */}
        <div className="px-8.5 py-6 h-[70dvh] overflow-y-scroll">
          {/* profile */}
          <Input
            inputContainerClass="form-input-container"
            value={state?.title}
            name="title"
            outsideLabel={t('title')}
            placeholder={t('starWars')}
            outsideLabelClass="text-sm font-bold text-darkerGray marked w-full flex flex-row gap-x-2 items-center"
            noLabelPaddingY="1rem"
            type="text"
            onChange={handleInputChange}
            errorMessage={errorMessages?.title}
            errorMessagePosition="bottom"
            showPopInfo={true}
            popInfoType="title"
            isTop={false}
          />
          {
            !groupTypes.includes(profile?.profile_type?.type) && (
              <InputGroup
                title={t('position')}
                subTitleLeft={t('jobRole')}
                subTitleRight={t('informationJob')}
                options={positionOptions}
                items={jobs}
                fieldKey="job_role"
                onChange={(e, index) => onChangeInput(e, index)}
                onSelect={(e, index) => onSelectJobRole(e, index)}
                onRemove={(index) => onRemoveJobRole(index)}
                onAdd={onAddPosition}
                hideAddButton={btnAddPositionHidden}
                errors={errorMessages}
                customClass="marked"
                showPopInfo={true}
                popInfoType="positions"
              />
            )
          }
          <div className="flex gap-4 milestone-location mt-4">
            <Input
              inputContainerClass="form-input-container"
              value={state?.platform}
              name="platform"
              outsideLabel={t('platform')}
              otherLabel={t('companyVenueNetwork')}
              placeholder={t('centuryFox')}
              optional={true}
              outsideLabelClass="text-sm font-bold text-darkerGray flex flex-row gap-x-2 items-center"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={errorMessages?.platform}
              showPopInfo={true}
              popInfoType="platform"
              left_popUp={{left:"80px", arrow_left:"80px"}}
            />
            {/* <Input
                inputContainerClass="form-input-container"
                value={state?.location}
                name="location"
                outsideLabel="Location"
                otherLabel="City/Town, Country"
                placeholder="e.g. Melbourne Australlia"
                optional={true}
                outsideLabelClass="text-sm font-bold text-darkerGray"
                noLabelPaddingY="1rem"
                type="text"
                onChange={handleInputChange}
                errorMessage={errorMessages?.location}
              /> */}

            <div className="form-input-container">
              <label for="location" className="text-sm font-bold text-darkerGray">
              <div className="flex flex-row gap-x-2 items-center">
                <div className="leading-4">
                  {t('location')}
                  <span className="font-normal"> ({t('optional')})</span>
                </div>
                <div className="text-black font-normal">
                  <PopInfo type={'location'} borderColor="border-darkerGray" verticalDirection="bottom"
                      direction={isMobile ? 'left' : 'right'} responsive = {isMobile ? {left: "80px", arrow_left:"80px"} : null}/>
                </div>
              </div>
              <span className="font-normal leading-4 text-sm text-darkerGray line-clamp-1">{t('cityTownState')}</span>
              </label>
              <div className="input-wrapper mt-2">
                <input ref={ref}  
                  className="input-class w-full" type="text" name="location" 
                  placeholder="Hobart, Tas, AUS" 
                  value={state?.location || ""}
                  onChange={handleInputChange}
                  style={{
                    padding:  "1rem",
                  }}
                  />
                  {
                    errorMessages?.location && 
                    <p className="input-error-message">* {errorMessages?.location}</p>
                  }
                </div>
              </div>
          </div>
          <WYSIWYGEditor
            label={
              <div className="flex items-center">
                {
                  t('description')
                }
                <div className="h-3 w-px bg-gray-400 mx-2"></div>
                <div className="italic font-light">
                  {t('writeInThePerson')}
                </div>
                <div className="text-black font-normal ml-2">
                  <PopInfo type={'description'} borderColor="border-darkerGray" responsive = {isMobile ? {right: "2px", arrow_right:"24px"} : null} direction={isMobile ? 'right' : 'left'} topCss="-8.5rem"/>
                </div>
              </div>
            }
            optional={false}
            value={state.description === 'null' ? "" : state.description}
            limitChar={1500}
            onChange={(value) =>
              handleInputChange({
                target: { name: "description", value },
              })
            }
            preserveWhitespace={true}
          />
          <FileUpload
            onUpload={onUploadImage}
            outsideLabel={t('addImage')}
            optional={true}
            preview={preview}
            setPreview={setPreview}
            onEdit={(image, type) => onEditThumbnail(image, type)}
            cropOnload={true}
            placeholder="imagefilename.jpg"
            accept="image/*"
            label={t('selectFile')}
            onDelete={handleDeleteImage}
            objectFit={'contain'}
            showPopInfo={true}
            popInfoType="image"
          />
          {/** media buttons */}
          {isSubscribed ? (
            <LinkGroupSelect
              options={mediaTypeOptions}
              subOptions={mediaSubTypes}
              label={t('addImagePDF')}
              optional={true}
              linkType={linkType}
              userData={userData}
              setItems={setLinkType}
              onAdd={onAddTypeLink}
              onUploadMultiple={(e, index) => onUploadMultipleLink(e, index)}
              onUpload={(e, index) => onUploadLink(e, index)}
              onChange={(e, index) => onTypeLink(e, index)}
              onSelect={(e, index) => onSelectTypeLink(e, index)}
              onBlur={(index) => onBlurTypeLink(index)}
              onRemove={(index) => onRemoveTypeLink(index)}
              onSelectSubType={(e, index) => onSelectSubTypeLink(e, index)}
              onRemoveMedia={(e, index) => onRemoveMediaLink(e, index)}
              onChangeLabel={(e, index) => onLabel(e, index)}
              facebookOrient ={(e, index) => facebookOrient(e, index)}
              errors={errorMessages}
              maxSelectedImages={maxSelectedImages}
              showPopInfo={true}
              popInfoType="add_button"
            />
          ) : (
              <LinkGroupSelect
                options={mediaTypeOptions}
                subOptions={mediaSubTypes}
                label={t('addImagePDF')}
                optional={true}
                linkType={linkType}
                userData={userData}
                setItems={setLinkType}
                onAdd={onAddTypeLink}
                hide={hide}
                currentButtonCount={state.currentButtonCount}
                isSubscribed={isSubscribed}
                onUploadMultiple={(e, index) => onUploadMultipleLink(e, index)}
                onUpload={(e, index) => onUploadLink(e, index)}
                onChange={(e, index) => onTypeLink(e, index)}
                onSelect={(e, index) => onSelectTypeLink(e, index)}
                onBlur={(index) => onBlurTypeLink(index)}
                onRemove={(index) => onRemoveTypeLink(index)}
                onSelectSubType={(e, index) => onSelectSubTypeLink(e, index)}
                onRemoveMedia={(e, index) => onRemoveMediaLink(e, index)}
                onChangeLabel={(e, index) => onLabel(e, index)}
                facebookOrient ={(e, index) => facebookOrient(e, index)}
                errors={errorMessages}
                maxSelectedImages={maxSelectedImages}
                showPopInfo={true}
                popInfoType="add_button"
              />
          )}
          <div className="w-full grid 1smd:grid-cols-2 1smd:gap-7">
            <DateInput
               label={t('start')}
              name="startDate"
              showApp={true}
              date={startDate}
              setDate={setStartDate}
              errors={errorMessages}
              fieldKey="start_date"
              required={true}
              isClearable={true}
              showPopInfo={true}
              popInfoType="start_end_dates"
            />
            <DateInput
              label={t('end')}
              name="endDate"
              showApp={true}
              // showPresent={
              //   `${startDate.year ?? "00"}-${startDate.month ?? "00"}-${
              //     startDate.day ?? "00"
              //   }` <= currentDate
              // }
              showPresent={true}
              date={endDate}
              setDate={setEndDate}
              errors={errorMessages}
              fieldKey="end_date"
              isClearable={true}
            />
          </div>
          {errorMessages?.errorDates && (
            <p className="text-sm text-red">{`*${errorMessages.errorDates[0]}`}</p>
          )}
          <div className="w-full grid 4sm:grid-cols-3 4sm:gap-6">
            <Input
              inputContainerClass="form-input-container"
              value={state?.date_note}
              name="date_note"
              outsideLabel={t('dateNote')}
              placeholder={t('episodesPerformances')}
              outsideLabelClass="text-sm font-bold text-darkerGray flex flex-row gap-x-2 items-center"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={errorMessages?.date_note}
              errorMessagePosition="bottom"
              showPopInfo={true}
              isTop={!isMobile}
              popInfoType="date_note"

            />
            <CreatableSelect
              isMulti
              label={t('Category')}
              options={categoriesOptions}
              placeholder={t('pleaseSelect')}
              // value={state.category} 
              defaultValue={milestone.categories.map((item => {return {label: item[currentLang()] || item.name, value:item.id}}))}
              height={58}
              onChange={(e) =>
                handleInputChange({
                  target: { name: "category", value: e },
                })
              }
              errorMessage={errorMessages?.category}
              labelClass="text-sm font-bold text-darkerGray leading-4 marked flex flex-row gap-x-2 items-center"
              showPopInfo={true}
              popInfoType="category"
            />
            <Select
              label={t('privacy')}
              // TODO: remove filter if verified and unlisted is needed
              options={privacies.filter(p => ['public', 'private'].includes(p.name.toLowerCase()))}
              placeholder={t('pleaseSelect')}
              name="privacy"
              value={state.privacy || ""}
              height={58}
              onChange={(e) =>
                handleInputChange({
                  target: { name: "privacy", value: e },
                })
              }
              errorMessage={errorMessages?.privacy}
              labelClass="text-sm font-bold text-darkerGray leading-4 marked flex flex-row gap-x-2 items-center"
              showPopInfo={true}
              popInfoType="privacy_milestone"
            />
          </div>

          <div className="w-full">
            <div className="flex space-x-2 items-center mb-2">
              <div className="">
                  {/* <Toggle
                    checked={adultContent}
                    name="adultContent"
                    onChange={(e) => setAdultContent(e?.target?.checked)}
                  /> */} 
                <CustomCheckbox
                  name={`adultContent`}
                  checked={adultContent}
                  onChange={(e) => handleSetAdultContent(e?.target?.checked)} 
                  isBoxType={true}
                /> 
                </div>
              <p className="text-base text-darkerGray font-bold flex items-center gap-2 flex-row">
                {t('containAdultContent')}
                <div className="text-black font-normal">
                  <PopInfo type={'adult_content'} borderColor="border-darkerGray" verticalDirection="top" topCss="-9.5rem" hideArrow={isMobile} responsive = {isMobile ? {left: "280px", arrow_left:"280px"} : null} />
                </div>
              </p>
            </div>
            <div className="flex space-x-2 items-center">
              <div>
                {/* <Toggle
                  checked={featured}
                  name="featured"
                  onChange={(e) => setFeatured(e?.target?.checked)}
                /> */}
                <CustomCheckbox
                  checked={featured}
                  name="featured"
                  onChange={(e) => setFeatured(e?.target?.checked)}
                  isBoxType={true}
                /> 
              </div>
              <p className="text-base text-darkerGray font-bold flex flex-row items-center gap-2">
              {t('pinThisMilestone')}
              <div className="text-black font-normal">
                <PopInfo type={'pin'} borderColor="border-darkerGray" containerClass="relative" verticalDirection="top" topCss="-9.5rem" responsive = {isMobile ? {left: "150px", arrow_left:"150px"} : null} hideArrow={isMobile}/>
              </div>
              </p>
            </div>
          </div>
        </div>
        {/* end content */}
      </div>
    </Modal>
    </div>
  );
}
